module.exports = __webpack_public_path__ + "img/2.69ab8995.png";